<template>
    <v-layout class="row justify-start justify-space-around" :class="isMobile ? 'mobile ml-3' : ''">
        <router-link :to="item.page" v-for="(item, i) in items" :key="i"
                     class="flex top-nav-link"
                     :class="{'px-1': isMobile ,'ml-1 pl-3' : !isMobile, 'club': item.title === 'Verein'}"
                     @click.native="changeRoute(item.page)"
        >
            <v-icon class="pt-1 " v-html="item.icon"></v-icon>
            <br v-if="isMobile">
            <span>{{ isMobile ? item.short : item.title}}</span>
        </router-link>
    </v-layout>
</template>
<script>
    import Notifications from "../../../content/notifications/Notifications";

    export default {
        name: 'router-links-list',
        components: {Notifications},
        props: {
            isMobile: {
                type: Boolean,
            },
        },
        data() {
            return {
                items: [{
                    icon: '💎',
                    title: 'Verein',
                    short: 'Verein',
                    page: '/club',
                },
                    {
                        icon: 'access_time', // insert_drive_file
                        title: 'Trainingsplan',
                        short: 'Plan',
                        page: '/schedule',
                    }, {
                        icon: 'photo_library',
                        title: 'Media Gallery',
                        short: 'Media',
                        page: '/gal',
                    }],
            };
        }, methods: {
            changeRoute(pagePath) {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
                if (this.$route.path === pagePath && this.isMobile) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: pagePath + '_same_page_route_mobile',
                        eventAction: 'navigate',
                        eventLabel: "top-nav",
                        eventValue: 1
                    });
                } else if (this.isMobile) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: this.$route.path + '_mobile',
                        eventAction: 'navigate',
                        eventLabel: "top-nav",
                        eventValue: 1
                    });
                } else {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: this.$route.path + '_desktop',
                        eventAction: 'navigate',
                        eventLabel: "top-nav",
                        eventValue: 1
                    });

                }
            }
        },

    };
</script>
<style lang="scss">
    .router-links-top-list.mobile {
        max-width: 160px;
        min-width: 160px;
        .top-nav-link.router-link-exact-active.router-link-active {
            padding-top: 0;
        }
        .top-nav-link {
            span {
                position: absolute;
                top: 35px;
                font-size: 10px;
            }
        }
    }
</style>
